import { Button } from '@/lib/Buttons';
import { TranslationKeys } from '@/localization';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type ConfirmationModalFooterProps = {
  onCancel: VoidFunction;
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
  cancelText?: TranslationKeys;
  confirmText?: TranslationKeys;
  footerClassName?: string;
};

export const ConfirmationModalFooter: FC<ConfirmationModalFooterProps> = ({
  onCancel,
  onConfirm,
  isLoading = false,
  cancelText = 'COMMON:cancel',
  confirmText = 'COMMON:confirm',
  footerClassName,
}) => {
  const { t } = useTranslation();

  return (
    <div className={twMerge('grid grid-cols-2 gap-3 pt-4 justify-self-end', footerClassName)}>
      <Button text={t(cancelText as any)} onClick={onCancel} intent='secondary' size='lg' className='size-full' disabled={isLoading} />
      <Button text={t(confirmText as any)} onClick={async () => await onConfirm()} size='lg' className='size-full' isLoading={isLoading} />
    </div>
  );
};
